import React from 'react';
import { Link, NavLink } from 'react-router-dom';

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `px-4 py-2 rounded-xl text-sm font-medium transition-colors duration-200 ${
    isActive 
      ? 'bg-brand-100/80 text-brand-900' 
      : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100/80'
  }`;

const Layout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className="min-h-full flex flex-col">
      <header className="glass-nav">
        <div className="container-page">
          <div className="flex items-center justify-between py-4">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-brand-500 to-brand-700 flex items-center justify-center text-white font-bold text-lg">
                AE
              </div>
              <span className="text-slate-900 text-lg font-semibold hidden sm:block">AE-Cloudsystem</span>
            </Link>
            
            <nav className="flex items-center gap-3">
              <NavLink to="/" className={navLinkClass} end>Home</NavLink>
              <NavLink to="/softwares" className={navLinkClass}>Softwares</NavLink>
              <a 
                href="mailto:contact@aecloudsystem.com" 
                className="btn-primary py-2"
              >
                Contact Us
              </a>
            </nav>
          </div>
        </div>
      </header>

      <main className="flex-1 relative">
        {/* Decorative gradient orbs */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none -z-10">
          <div className="absolute -top-40 -right-40 w-96 h-96 bg-brand-200 rounded-full opacity-20 blur-3xl animate-float"></div>
          <div className="absolute top-60 -left-40 w-96 h-96 bg-blue-200 rounded-full opacity-20 blur-3xl animate-float" style={{ animationDelay: '-2s' }}></div>
          <div className="absolute -bottom-40 right-60 w-96 h-96 bg-purple-200 rounded-full opacity-20 blur-3xl animate-float" style={{ animationDelay: '-4s' }}></div>
        </div>
        
        <div className="container-page py-12">
          {children}
        </div>
      </main>

      <footer className="mt-20 border-t border-slate-200/50 bg-white/50 backdrop-blur-sm">
        <div className="container-page py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="font-semibold text-slate-900 mb-3">AE-Cloudsystem Oy</h3>
              <p className="text-slate-600 text-sm">Building the future of cloud software since 2024.</p>
            </div>
            <div>
              <h3 className="font-semibold text-slate-900 mb-3">Products</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/softwares/ratemyapp" className="text-slate-600 hover:text-brand-600">RateMyApp</Link></li>
                <li><Link to="/softwares/ratemyapp/terms" className="text-slate-600 hover:text-brand-600">Terms & Conditions</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold text-slate-900 mb-3">Connect</h3>
              <ul className="space-y-2 text-sm">
                <li><a href="https://github.com/aecloudsystem" className="text-slate-600 hover:text-brand-600">GitHub</a></li>
                <li><a href="mailto:contact@aecloudsystem.com" className="text-slate-600 hover:text-brand-600">Email Us</a></li>
              </ul>
            </div>
          </div>
          <div className="mt-8 pt-8 border-t border-slate-200/50 text-sm text-slate-600">
            <p>© {new Date().getFullYear()} AE-Cloudsystem Oy. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;